export const formatTableV2RunNumber = (runNumber: number | null | undefined): string | null =>
  runNumber === null || runNumber === undefined ? null : `#${String(runNumber)}`;

export const joinTableV2SecondaryParts = (
  parts: Array<string | null | undefined>,
): string | null => {
  const filteredParts = parts.filter((part): part is string => Boolean(part?.trim()));
  return filteredParts.length > 0 ? filteredParts.join(' | ') : null;
};
